import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import ReactQuill from "react-quill";
import get from "lodash/get";
import TextField from "@material-ui/core/TextField";
import CallOut from "Component/Headers/callOut";
import { instance } from "Actions/AxiosInstance";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import "./index.scss";
import CallOutNew from "Component/Headers/callOutNew";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];
class company_email extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        sendername: "",
        replytoemail: "",
        sendersignature: "",
      },
      list: {
        subscriptiontypeid: {
          displayvalue: "",
          displayname: "",
        },
      },
      errors: {},
    };
  }

  componentDidMount() {
    if (!this.props.dashboard && this.props.stepcompleted > this.props.step) {
      this.GetForm();
    } else if (this.props.dashboard) {
      this.GetForm();
    }
    this.GetForm();
  }

  GetForm() {
    const URL = `account/emailbranding/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}`;
    instance
      .get(URL)
      .then((result) => {
        const data = result.data.result[0];
        const fields = {
          sendername: get(data, "sendername", ""),
          // senderemail: get(data, "senderemail", ""),
          replytoemail: get(data, "replytoemail", ""),
          sendersignature: get(data, "sendersignature", ""),
        };

        // let subscriptiontypeid = this.state.subscriptionTypeList.find(
        //   x => x.displayvalue == data.subscriptiontypeid
        // );
        // let list = this.state.list;
        // list.subscriptiontypeid = subscriptiontypeid;
        this.setState({ fields });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    const { errors } = this.state;
    field == "sendersignature"
      ? (fields[field] = e)
      : (fields[field] = e.target.value);
    if (field == "replytoemail") {
      if (
        /^\w+([\.-]?\w+)*([+]{0,1}\w+){0,1}@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(
          e.target.value,
        )
      ) {
        errors.replytoemail = false;
      } else {
        errors.replytoemail = true;
      }
    }
    this.setState({ fields, errors });
    // ValidateAction(this.state, field, type);
  }

  OnFieldChange1 = (value, name, type) => {
    const { fields } = this.state;
    const { errors } = this.state;
    fields[name] = value;
    this.setState({ fields, errors });
    // ValidateAction(this.state, field, type);
  };

  OnFormSubmit() {
    if (this.state.errors.replytoemail) {
      this.props.enqueueSnackbar("Please check the email address", {
        variant: "error",
      });
    } else {
      const data = {
        sendername: this.state.fields.sendername,
        senderemail: null,
        replytoemail: this.state.fields.replytoemail,
        sendersignature: this.state.fields.sendersignature,
        // stepcompleted: this.props.dashboard
        //   ? this.props.currentsubscription.stepcompleted
        //   : this.props.stepcompleted > this.props.step
        //   ? this.props.stepcompleted
        //   : this.props.step,
      };
      const URL = `account/emailbranding/${get(
        this.props,
        "SubscriptionInfo.SubscriptionData.subscriptionid",
        "",
      )}`; // 'account/branddetail/' + this.state.subscriptionid;

      instance
        .put(URL, data)
        .then((result) => {
          this.setState({
            ...result.data.result,
          });
          // if (this.props.dashboard) {
          //   this.props.enqueueSnackbar("Saved successfully", {
          //     variant: "success",
          //   });
          // }
          // if (!this.props.dashboard) {
          //   this.props.updateStep(3);
          // }
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <p className="large-text-dark-secondary t-bold margin-bottom-24">
          Email branding
        </p>

        <Grid container spacing={2}>
          <Grid item sm={12} md={8}>
            <div className="margin-bottom-16">
              <p className="input-label">Sender Name</p>
              <TextField
                id="outlined-bare"
                className="expense-cycle-input width100 margin-bottom-8"
                type="text"
                onChange={this.OnFieldChange.bind(this, "sendername", "text")}
                value={this.state.fields.sendername}
                maxLength="50"
                variant="outlined"
                autoComplete="off"
              />
              <CallOutNew
                classnames="bg-light-red"
                header="This name will be displayed in all your HRMS email notifications. Ideally, it should be the 'HR Team'."
                emoji="⚠️"
                textcolor="#f86b07"
              />
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">Reply-to email address (Optional)</p>

              <TextField
                className="expense-cycle-input width100 margin-bottom-8"
                type="email"
                id="outlined-bare"
                maxLength="50"
                onChange={this.OnFieldChange.bind(
                  this,
                  "replytoemail",
                  "email",
                )}
                value={this.state.fields.replytoemail}
                variant="outlined"
              />
              <CallOutNew
                classnames="bg-light-red"
                header="We will direct all replies to HRMS notifications (from employees) to this email ID. Ideally, it should be your HR group ID/inbox. "
                emoji="⚠️"
                textcolor="#f86b07"
              />
            </div>
            <div>
              <p className="input-label">Email signature (Optional)</p>
              <span>
                <ReactQuill
                  theme="snow"
                  value={this.state.fields.sendersignature || ""}
                  modules={modules}
                  formats={formats}
                  onChange={(content, delta, source, editor) => {
                    const value =
                      editor
                        .getText()
                        .split("\n")
                        .join("")
                        .split(" ")
                        .join("") == ""
                        ? null
                        : content;
                    this.OnFieldChange1(value, "sendersignature", "text");
                  }}
                />
              </span>
              <CallOutNew
                classnames="bg-light-red margin-top-8"
                header="This templated signature will be attached at the bottom of all email communications & notifications sent through sumHR"
                emoji="⚠️"
                textcolor="#f86b07"
              />
            </div>
          </Grid>
        </Grid>

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div className="floatright" style={{ marginRight: 72 }}>
            <div>
              <Button
                color="primary"
                variant="contained"
                className="btn btn-primary-md-blue"
                onClick={this.OnFormSubmit.bind(this)}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="clearfloat"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  onboarding: state.Onboarding,
});

export default connect(
  mapStateToProps,
  // mapDispatchToProps,
)(withSnackbar(company_email));
